{
  "title": "Briefs",
  "table": {
    "name": "Nombre",
    "created": "Creado",
    "actions": "Acciones",
    "empty": "Aún no hay briefs. Crea uno para dar contexto a tus asignaciones."
  },
  "includeArchived": "Incluir archivados",
  "new": "Nuevo brief",
  "archivedBadge": "Archivado",
  "form": {
    "name": "Nombre",
    "description": "Descripción",
    "descriptionHelp": "Puedes usar Markdown."
  },
  "createTitle": "Nuevo brief",
  "create": "Crear brief",
  "created": "Brief creado",
  "editTitle": "Editar brief",
  "edit": "Editar",
  "saved": "Brief guardado",
  "archive": "Archivar",
  "unarchive": "Restaurar",
  "archivedToast": "Brief archivado",
  "unarchivedToast": "Brief restaurado",
  "noDescription": "Aún no tiene descripción.",
  "assignmentsTitle": "Asignaciones con este brief",
  "notFound": "No se encontró el brief."
}
